export default "__VITE_ASSET__0e549598__"